import React from 'react';
import { Image, Link, TeslaButton } from 'components';

import * as styles from './styles.module.scss';

const ModelDetailCard = ({ data, variant = 'secondary' }) => {
  const {
    image,
    car_type: type,
    car_name: name,
    car_tagline: tagline,
    price,
    car_description: description,
    cta_text: ctaText,
    cta_link: ctaLink,
  } = data;
  const classNames = variant === 'tesla' ? styles.tesla : '';

  // content checks
  const nameText = name?.text;
  const taglineText = tagline?.text;
  const descriptionText = description?.text;
  const priceText = price?.text;
  const hasCta = ctaText?.text && ctaLink?.url;

  const ButtonEle = variant === 'tesla' ? TeslaButton : Link;
  const buttonTheme = variant === 'tesla' ? 'blackOutline' : 'secondary';

  return (
    <article className={`${styles.container} ${classNames} `}>
      <Image className={styles.image} image={image} />

      {type && <p className={styles.type}>{type}</p>}

      <div className={styles.content}>
        <div className={styles.titles}>
          {nameText && <p className={styles.name}>{name?.text}</p>}
          {taglineText && <p className={styles.tagline}>{tagline?.text}</p>}
        </div>

        {priceText && (
          <p className={styles.price}>
            {price?.text}
            <span className={styles.priceSuffix}> pw*</span>
          </p>
        )}

        {descriptionText && <p className={styles.description}>{description?.text}</p>}

        {hasCta && (
          <ButtonEle to={ctaLink.url} theme={buttonTheme} className={`button white ${styles.button}`}>
            {ctaText?.text}
          </ButtonEle>
        )}
      </div>
    </article>
  );
};

export default ModelDetailCard;
